<template>
  <div class="container">
    <div class="row justify-content-start">
      <!-- Symptoms  -->
      <v-row no-gutters class="mx-0">
        <v-col class="mb-5" cols="12" sm="12" md="12" lg="12">
          <h2>Symptoms</h2>
        </v-col>
        <v-col
          class="mb-2"
          cols="12"
          sm="12"
          md="5"
          lg="4"
          v-for="item in symptoms"
          :key="item.title"
        >
          <v-card class="mx-auto" max-width="344">
            <v-img :src="item.image" height="200px"></v-img>

            <v-card-title> {{ item.title }} </v-card-title>

            <v-card-text class="text-truncate">
              {{ item.caption }}
            </v-card-text>

            <v-card-actions>
              <v-btn
                @click="selected = item.title"
                color="blueblack"
                text
                outlined
                rounded
                class="mb-5"
              >
                Read Symptom
              </v-btn>

              <v-spacer></v-spacer>

              <v-btn v-if="selected" icon @click="selected = ''">
                <v-icon>{{
                  selected ? "mdi-chevron-up" : "mdi-chevron-down"
                }}</v-icon>
              </v-btn>
            </v-card-actions>

            <v-expand-transition>
              <div v-if="selected === item.title">
                <v-divider></v-divider>

                <v-card-text>
                  {{ item.description }}
                </v-card-text>
              </div>
            </v-expand-transition>
          </v-card>
        </v-col>
      </v-row>

      <!-- Prevention -->

      <v-row no-gutters class="mx-0">
        <v-col class="mt-5 mb-5" cols="12" sm="12" md="12" lg="12">
          <h2>Preventions</h2>
        </v-col>
        <v-col
          class="mb-2"
          cols="12"
          sm="12"
          md="5"
          lg="4"
          v-for="(item, index) in preventions"
          :key="index"
        >
          <v-card class="mx-auto" max-width="344">
            <v-img :src="item.image" height="200px"></v-img>

            <v-card-title> {{ item.title }} </v-card-title>

            <v-card-text class="text-truncate">
              {{ item.caption }}
            </v-card-text>

            <v-card-actions>
              <v-btn
                @click="selected = item.title"
                color="blueblack"
                text
                outlined
                rounded
                class="mb-5"
              >
                Read Prevention
              </v-btn>

              <v-spacer></v-spacer>

              <v-btn v-if="selected" icon @click="selected = ''">
                <v-icon>{{
                  selected ? "mdi-chevron-up" : "mdi-chevron-down"
                }}</v-icon>
              </v-btn>
            </v-card-actions>

            <v-expand-transition>
              <div v-if="selected === item.title">
                <v-divider></v-divider>

                <v-card-text>
                  {{ item.description }}
                </v-card-text>
              </div>
            </v-expand-transition>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import { mapFields } from "vuex-map-fields";
import { mapActions } from "vuex";
export default {
  async created() {
    await this.fetchTotalSymptoms(this.lang);
    await this.fetchTotalPreventions(this.lang);
  },
  props: {
    lang: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapFields("symptom_prevent", ["totalSymptoms", "totalPreventions"]),
  },
  data: () => ({
    selected: "",
    symptoms: [],
    preventions: [],
  }),
  methods: {
    ...mapActions("symptom_prevent", [
      "fetchTotalSymptoms",
      "fetchTotalPreventions",
    ]),
  },
  watch: {
    lang: {
      immidate: true,
      async handler(value) {
        console.log(value);
        await this.fetchTotalSymptoms(value);
        await this.fetchTotalPreventions(value);

      },
    },
    totalSymptoms: {
      immidate: true,
      handler(value) {
        this.symptoms = value;
      },
    },
    totalPreventions: {
      immidate: true,
      handler(value) {
        this.preventions = value
      },
    },
  },
};
</script>

